/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Session_Time_Short_MorningInputs */

const vi_stocktake_session_time_short_morning = /** @type {(inputs: Stocktake_Session_Time_Short_MorningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sáng`)
};

/**

* @param {Stocktake_Session_Time_Short_MorningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_session_time_short_morning = /** @type {((inputs?: Stocktake_Session_Time_Short_MorningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Session_Time_Short_MorningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_session_time_short_morning(inputs)
});